import { render, staticRenderFns } from "./GlossCodeAutocomplete.vue?vue&type=template&id=35fdd137"
import script from "./GlossCodeAutocomplete.vue?vue&type=script&lang=js"
export * from "./GlossCodeAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./GlossCodeAutocomplete.vue?vue&type=style&index=0&id=35fdd137&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports